import {ImportedData} from "../../../data/model";
import {Product} from "../../../products/model";
import {Service} from "../../../services/model";
import {Style} from "../../../styles/model";

export interface SortSettings {
  column: string | null;
  direction: SortDirection | null;
}

export enum SortDirection {
  asc = "asc",
  desc = "desc",
  asc_folderTop = "asc_folderTop",
  desc_folderTop = "desc_folderTop"
}

export const sortItems = (items: ImportedData[] | Product[] | Service[] | Style[],
                          valueForColumn: (item: ImportedData | Product | Service | Style,
                                           column?: string | null) => any,
                          sortSettings: SortSettings | null) => {
  const {column, direction} = sortSettings || {column: null, direction: null};
  if (!column || !direction) {
    return items.slice();
  }
  const copy = items.slice();
  copy.sort((a, b) => {
    const va = valueForColumn(a, column);
    const vb = valueForColumn(b, column);
    if (va < vb) {
      return direction.startsWith("asc") ? -1 : 1;
    }
    if (va > vb) {
      return direction.startsWith("asc") ? 1 : -1;
    }
    return 0;
  });

  if (direction.endsWith("_folderTop")) {
    copy.sort((a, b) => {
      const va = valueForColumn(a, "dataFormat");
      const vb = valueForColumn(b, "dataFormat");
      if (va === "folder" && vb !== "folder") {
        return -1;
      }
      if (vb === "folder" && va !== "folder") {
        return 1;
      }
      return 0;
    });
  }

  return copy;
}

export const updateSortIndicators = (sortColumn, sortDirection, columnKey) => {
  const sortIndicators = document.getElementsByClassName("sortIndicator");
  for (const indicator of sortIndicators) {
    indicator.innerHTML = "";
  }
  const sortIndicator = document.getElementById(`sortIndicator_${columnKey}`);
  if (sortIndicator) {
    let indicator = sortColumn === columnKey && sortDirection.startsWith("asc") ? " ▲" : " ▼";
    if (sortColumn === columnKey && sortDirection.endsWith("_folderTop")) {
      indicator += " 🗀";
    }
    sortIndicator.innerHTML = indicator;
  }
}

